import Axios from "./axios";

const resource = "promotion-shop-plans";

export default {
	get(id) {
		return Axios.get(`${resource}`, {
			params: {
				reseller_id: id
			}
		});
	},
	show(id) {
		return Axios.get(`${resource}/${id}`);
	},
	/**
	 * Check if code exists
	 * @param {*} id - reseller id
	 * @param {*} code - plan code
	 * @returns plan info
	 */
	check(id, code='') {
		return Axios.post(`${resource}/check/code`, {reseller_id: id, code: code})
	}
}